import { useEffect, useRef } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import CookieBanner from "./CookieBanner";
import { captureStudioKey } from "@/lib/studio";
import { useSettings } from "@/context/SettingsContext";

// Barra announcement sottile — premium, non una seconda fascia di navigazione
function AnnouncementBar() {
  const { settings } = useSettings();
  if (!settings.shop_visible) return null;
  return (
    <div className="bg-ink text-bone/80" data-testid="announcement-bar">
      <div className="container-x py-1.5 flex justify-center">
        <Link to="/shop-the-project" className="text-[10px] tracking-[0.12em] uppercase hover:text-gold transition-colors text-center leading-tight">
          <span className="hidden sm:inline">Progetta con lo Studio. Accedi a condizioni esclusive sullo Shop <span className="text-gold">→ Scopri Shop the Project</span></span>
          <span className="sm:hidden">Clienti Studio: condizioni esclusive sullo Shop <span className="text-gold">→</span></span>
        </Link>
      </div>
    </div>
  );
}

export default function Layout() {
  const lenisRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    captureStudioKey(location.search);
  }, [location.search]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-bone">
      <Navbar />
      <main className="flex-1 pt-20">
        <AnnouncementBar />
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <CookieBanner />
    </div>
  );
}
